export interface NavigationConfig {
  id: string;
  label: string;
  icon: string;
  path: string;
  action?: 'navigate' | 'modal' | 'external';
}

export const NAVIGATION_ITEMS: NavigationConfig[] = [
  {
    id: 'home',
    label: 'Home',
    icon: '🏠',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'crates',
    label: 'My Crates',
    icon: '📦',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'upload',
    label: 'Upload',
    icon: '⬆️',
    path: '/dashboard',
    action: 'modal'
  },
  {
    id: 'secrets',
    label: 'Secrets',
    icon: '🔐',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'account',
    label: 'Account',
    icon: '👤',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'download',
    label: 'Download',
    icon: '⬇️',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'report',
    label: 'Get Support',
    icon: '🆘',
    path: '/dashboard',
    action: 'navigate'
  },
  {
    id: 'resources',
    label: 'Help Videos',
    icon: '🎥',
    path: '/dashboard',
    action: 'navigate'
  }
];
